<template>
  <svg
    :class="[size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45.78 43.78"
  >
    <g>
      <path
        class="cls-1"
        d="M9.51,17.82c.73-.01,1.32-.62,1.32-1.35V4.65c0-1.07.87-1.95,1.95-1.95h7.55c.67,0,1.21.54,1.21,1.21v8.9c0,1.82,1.48,3.29,3.29,3.29h9.05c.51,0,.97.32,1.14.8.19.54.7.91,1.28.91h0c.73,0,1.35-.64,1.35-1.4v-.62c0-.77-.23-1.51-.65-2.15l-.24-.32L24.31.89l-.31-.23c-.64-.43-1.38-.65-2.15-.65h-10.42c-1.82,0-3.29,1.48-3.29,3.29v13.13c0,.38.16.74.43,1.01.26.26.63.4.95.39ZM24.24,6.69c0-.42.25-.79.64-.96.39-.16.83-.07,1.13.22l5.68,5.68c.3.3.39.74.22,1.13-.16.39-.54.64-.96.64h-5.22c-.82,0-1.49-.67-1.49-1.49v-5.22Z"
      />
      <polygon
        class="cls-1"
        points="36.51 13.06 24.8 1.35 36.65 13.21 36.51 13.06"
      />
      <path
        class="cls-1"
        d="M41.29,19.92H4.49c-2.48,0-4.49,2.02-4.49,4.49v10.18c0,2.48,2.01,4.49,4.49,4.49h3.65v1.41c0,1.82,1.48,3.29,3.29,3.29h22.92c1.82,0,3.29-1.48,3.29-3.29v-1.41h3.64c2.48,0,4.49-2.01,4.49-4.49v-10.18c0-2.48-2.02-4.49-4.49-4.49ZM34.94,39.58c0,.82-.67,1.49-1.49,1.49H12.33c-.82,0-1.49-.67-1.49-1.49v-3.47c0-.82.67-1.5,1.49-1.5h21.12c.82,0,1.49.67,1.49,1.5v3.47ZM43.08,33.62c0,1.52-1.24,2.76-2.76,2.76h-1.47c-.67,0-1.21-.54-1.21-1.21v-1.91c0-.06,0-.11-.01-.17v-.06s-.02-.05-.02-.05c-.05-.25-.17-.48-.36-.67-.21-.21-.44-.33-.7-.38l-.1-.02c-.06,0-.11-.01-.17-.01H9.49c-.06,0-.11,0-.17.01l-.11.02c-.25.05-.48.17-.67.36-.14.15-.23.28-.3.43-.05.11-.07.19-.09.27v.1c-.02.06-.03.11-.03.17v1.91c0,.67-.54,1.21-1.21,1.21h-1.47c-1.52,0-2.76-1.24-2.76-2.76v-8.24c0-1.52,1.24-2.76,2.76-2.76h34.87c1.52,0,2.76,1.24,2.76,2.76v8.24Z"
      />
      <path
        class="cls-1"
        d="M35.22,24.98c-1.08.23-1.77,1.3-1.54,2.38.23,1.08,1.3,1.77,2.38,1.54,1.08-.23,1.77-1.3,1.54-2.38-.23-1.08-1.3-1.77-2.38-1.54Z"
      />
    </g>
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
